export default class PromiseQueue {
  constructor() {
    this._deferreds = [];
    this._isPaused = false;
  }

  _defer(cb) {
    return new Promise((resolve, reject) =>
      this._deferreds.push({ cb, resolve, reject }));
  }

  _flush() {
    this._deferreds.map(({ cb, resolve, reject }) => {
      return { promise: this._promise(cb), resolve, reject };
    }).forEach(({ promise, resolve, reject }) => {
      promise.then(resolve, reject);
    });

    this._deferreds = [];
  }

  async _promise(cb) {
    return cb();
  }

  get isPaused() {
    return this._isPaused;
  }

  async push(cb) {
    return this._isPaused ? this._defer(cb) : await cb();
  }

  pause() {
    this._isPaused = true;
  }

  resume() {
    this._flush();
    this._isPaused = false;
  }
}
